import bindAll from "lodash.bindall";
import http from "../../../http";
import { getParamsFromQuery, sliceObject, getQuery } from "../xes-lib";
// import { getGoldUrl, getCanBeShare, genQrCode, genShareUrl, getEnv, Environment } from "../xes";
import { extractVmJson } from "../xes";
import xesAssistant from '../xesAssistant';
import { sessionStore } from '../local-store';
import { localServer } from 'xes-code-base/lib/wrapper/vue/http/localServer.js'


import { onXESCheckBackGround } from "../../../reducers/project-state.js";

import ClassHandler from './classHandler.js';
class BaizeHandler extends ClassHandler {
  constructor() {
    super()
    this.liveParams = getParamsFromQuery("all")
    this.isRight = 0

    bindAll(this, [
      'getProjectData',
      'getSubmitFunction',
      'postMessage',
      'messageHandle',
      'getBaizeGoldCoin',
      'answerRightCollectionHandle'
    ])
    // fit ios xesApp
    // const fitXesApp = /13_5 like Mac OS X.*jzh/.test(window.navigator.userAgent)
    // const needRefresh = !window.location.search.includes('needRefresh')
    // if(fitXesApp && needRefresh) {
    //   window.location.href = window.location.href.replace(/\?/, '?needRefresh=true&')
    // }

    window.addEventListener('message', this.messageHandle)
    window.parent.postMessage({
      from: 'sync',
      type: 'sendSyncAnswer',
      data: {
          isAnswer: true
      }
    }, '*')
  }
  async getProjectData() {
    const isNew = getQuery('paper_version');
    if (!isNew) {
      const commit_id = getQuery('commit_id')
      const problem_id = getQuery('problem_id')
      if(commit_id){
        return http.getBaizeAnswerProject({
          commit_id
        })
      }
      return http.getBaizeProject({
        problem_id
      })
    }
    // 新组卷逻辑
    const practiceCommitId = getQuery('practice_commit_id');
    const queId = getQuery('que_id');
    const problemId = getQuery('problem_id');
    const problemResult = await http.getBaizeProjectNew({
        problem_code: problemId
    });
    if (practiceCommitId) {
        const commitResult = await http.getBaizeAnswerProjectNew({
            practice_commit_id: practiceCommitId,
            que_id: queId,
            problem_code: problemId,
            stuId: getQuery('stuId')
        });
        if (commitResult) {
            const problem = problemResult.problem;
            const userAnswer = commitResult.user_answer ? JSON.parse(commitResult.user_answer) : {};
            userAnswer.block_mode = problem.block_mode;
            userAnswer.block_mode_data = problem.block_mode_data;
            return Promise.resolve(userAnswer);
        }
    }
    return Promise.resolve(problemResult.problem);
  }
  async getTemplateData() {
    const isNew = getQuery('paper_version');
    const problem_id = getQuery('problem_id')
    if (!isNew) {
      return http.getBaizeProject({
        problem_id
      })
    }
    // 新组卷逻辑
    const problemResult = await http.getBaizeProjectNew({
      problem_code: problem_id
    });
    return Promise.resolve(problemResult.problem);
  }
  getSubmitFunction(projectParams, varParams) {
    const { 
      name,
      xml,
      project_changed
    } = projectParams
    const problem_id = getQuery('problem_id')
    const isNew = getQuery('paper_version');
    if (isNew) {
      // 此处需要交给上游去提交啦
      /* eslint-disable */
      const answerURL = location.href
      /* eslint-enable */
      return Promise.resolve({
          practice_commit_id: getQuery('practice_commit_id'),
          que_id: getQuery('que_id'),
          problem_code: problem_id,
          is_right: this.isRight,
          user_answer: JSON.stringify({name, xml, answerURL}),
          need_judge: 0,
          project_changed: project_changed
      });
    }
    const commit_id = getQuery('commit_id')
    return http.submitBaizeProject({
      problem_id,
      commit_id,
      name,
      xml
    })
  }
  check(projectMeta){
    return this.handleLockMethod(() => {
      let projectParams = sliceObject([
        "xml",
      ], projectMeta)
      projectParams['xml'] = extractVmJson(projectParams['xml'])
      const isNew = getQuery('paper_version');
      let checkHandle = http.checkBaizeProject;
      if (isNew) {
        checkHandle = http.checkBaizeProjectNew;
      }
      return new Promise((resolve, reject) => {
        checkHandle({
          ...projectParams,
          problem_id: this.liveParams.problem_id,
          problem_code: this.liveParams.problem_id
        }).then(res => {
          let _isRight = res.data.data.result === 'success'
          this.isRight = ~~_isRight
          window.baizeAnswerIsRight = this.isRight
          this.checkData = res
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
      })
    })
  }
  getBaizeGoldCoin(mission_id, que_id, is_right) {
    return http.getBaizeGoldCoin({
      mission_id,
      que_id,
      is_right
    })
  } 
  // 答题连对处理
  answerRightCollectionHandle(answerResultCollection = [], queDataList = [], rewards = []) {// answerResultCollection 形如[0, 1, 1, 0] 1对0错
    try{if (!answerResultCollection[answerResultCollection.length - 1]) {
      // 这次做题做错了，连对被终结的场景
      return {
        count: 0,
        type: 'underway',
        rewards
      }
    } else {
      const rightStopIndex = answerResultCollection.lastIndexOf(1)
      const rightStartIndex = answerResultCollection.lastIndexOf(0)
      console.log(rightStartIndex, rightStopIndex)
      const collectionCount = rightStopIndex - rightStartIndex
      console.log('连对数量', collectionCount)
      if ((collectionCount >= 3 && answerResultCollection.length === queDataList.length) || collectionCount >= 10) {
        return {
          count: collectionCount,
          type: 'destination',
          rewards
        }
      } else {
        return {
          count: collectionCount,
          type: 'underway',
          rewards
        }
      }
    }
  }catch(e) {
    console.log('error---', e);
  }
  }
  onDoneSubmit(state, dispatch, data, hasNextTemplateProjectId,workType) {
    const isNew = getQuery('paper_version');
    if(xesAssistant.isPc() || isNew) {
      this.postMessage && this.postMessage(data)
    } else {
      const localAnswerData = sessionStore.get('localAnswerData')
      /* eslint-disable */
      const answerURL = isNew ? location.href : `https://code.xueersi.com/scratchmb/index.html?problem_id=${data.problem_id}&commit_id=${data.commit_id}&env=xes_syncwork`;
      /* eslint-enable */
      const userAnswerData = [
        {
          judge: [this.isRight],  //对或错
          queId: localAnswerData.currentAnswerData.queId,  // 题目的id  通过localAnswerData. currentAnswerData
          answerURL,
          commitId: data.commit_id,
          problemId: data.problem_id
        }
      ]
      sessionStore.store('userAnswerData', userAnswerData)

      sessionStore.store('isFill', '1')
      sessionStore.store('isFreshAnswer', '0')
      sessionStore.store('isFreshAnalysis', '0')
      const logData = localAnswerData.currentDotData
      localServer.log('after-home-answer', 'answer-page-submit-btn', null, {
        resourceid: logData.resourceid,
        htindex: logData.htindex,
        testtype: logData.testtype,
        ifcorrect: this.isRight, //
        answer: '',
        exam_id: logData.exam_id,
        answer_time: window.pageDidMountTime - new Date().getTime(), // 
        is_new: logData.is_new
      })
      
      var answerResultCollection = localAnswerData.answerResultCollection
      var queDataList = localAnswerData.queDataList
      answerResultCollection.push(this.isRight)
      var url = sessionStore.get('answer_url')
      var mission_id = getQuery('missionId', '', url)
      this.getBaizeGoldCoin(mission_id, localAnswerData.currentAnswerData.queId, this.isRight).then(res => {
        var answerData = this.answerRightCollectionHandle(answerResultCollection, queDataList, res.rewards)
        console.log('aa----', answerData);
        window.dbgstore.dispatch({type:'baize/OPEN_MODAL',modal:'baizeLottie', baizeRightCount: answerData})
        return res
      }).catch(e => {console.log(e)})
      

    }

  }
  postMessage(data) {
    const isNew = getQuery('paper_version');
    /* eslint-disable */
    const answerURL = isNew ? location.href : `https://code.xueersi.com/scratchmb/index.html?problem_id=${data.problem_id}&commit_id=${data.commit_id}&env=xes_syncwork`
    /* eslint-enable */
    if (isNew) {
      let user_answer = data.user_answer ? JSON.parse(data.user_answer) : {};
      const queId = getQuery('que_id');
      user_answer.lang = 'scratchmb';
      user_answer = JSON.stringify(user_answer);
      const postData = {
          judge: [this.isRight],
          queId: queId,
          // 用户作答之后的链接 answerURL， 参考为python/c++ 链接 
          answerURL: answerURL,
          is_right: this.isRight,
          // 用户作答的题目id (模板)
          problem_code: data.problem_code,
          // 用户的作答
          user_answer: user_answer,
          need_judge: 0,
          project_change: data.project_changed
      };
      window.parent.postMessage({
        from: 'sync',
        type: 'sendSyncSubmitResultNew',
        data: {
            ...postData
        }
      }, '*');
      return;
    } 
    // const result = (data.data && data.data.data.result) === 'success' ? 1 : 0
    window.parent.postMessage({
      from: 'sync',
      type: 'sendSyncSubmitResult',
      data: {
        // judge Array类型， 是否作对 ，对[1] 错 [0]
        judge: [this.isRight],
        // 用户作答之后的链接 answerURL， 参考为python/c++ 链接 
        answerURL,
        // 用户作答的id
        commit_id: data.commit_id,
        // 用户作答的题目id (模板)
        problem_id: data.problem_id,
      }
    }, '*') 
  }
  messageHandle(event) {
    // from 来自哪个页面，exam答题页面 analysis 解析页面
    if (event.data && event.data.from === 'exam') {
      const data = event.data.data
      console.log('接收到EXAM父级页面的信息', data)
      // 父级页面对子级页面下发动作信息的类型
      const type = event.data.type
      switch (type) {
        case 'submitAnswer':
          // 提交信息，保存提交之后的答案链接等等
          this.dispatch(onXESCheckBackGround('submit'))
          break
      }
    }
  }
  static getInstance() {
    if (BaizeHandler.instance === null) {
      BaizeHandler.instance = new BaizeHandler()
    }
    return BaizeHandler.instance
  }
}
BaizeHandler.instance = null

export default BaizeHandler
